import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import { paperProps } from '../../constants/styles';

const StyledTextField = ({ sx, ...rest }: TextFieldProps) => (
  <TextField
    SelectProps={{ MenuProps: { PaperProps: { sx: paperProps } } }}
    {...rest}
    sx={{
      div: {
        backgroundColor: (t) => t.palette.background.paper,
      },
      ...sx,
    }}
  />
);

export default StyledTextField;
